/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Search_Modal_Available_FreeInputs */

const en_domain_search_modal_available_free = /** @type {(inputs: Domain_Search_Modal_Available_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available & free`)
};

const es_domain_search_modal_available_free = /** @type {(inputs: Domain_Search_Modal_Available_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible y gratuito`)
};

const fr_domain_search_modal_available_free = /** @type {(inputs: Domain_Search_Modal_Available_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible et gratuit`)
};

const de_domain_search_modal_available_free = /** @type {(inputs: Domain_Search_Modal_Available_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbar & kostenlos`)
};

/** @type {(inputs: Domain_Search_Modal_Available_FreeInputs) => LocalizedString} */
const ja_domain_search_modal_available_free = en_domain_search_modal_available_free;

/** @type {(inputs: Domain_Search_Modal_Available_FreeInputs) => LocalizedString} */
const zh_domain_search_modal_available_free = en_domain_search_modal_available_free;

/** @type {(inputs: Domain_Search_Modal_Available_FreeInputs) => LocalizedString} */
const ar_domain_search_modal_available_free = en_domain_search_modal_available_free;

/** @type {(inputs: Domain_Search_Modal_Available_FreeInputs) => LocalizedString} */
const id_domain_search_modal_available_free = en_domain_search_modal_available_free;

/** @type {(inputs: Domain_Search_Modal_Available_FreeInputs) => LocalizedString} */
const it_domain_search_modal_available_free = en_domain_search_modal_available_free;

/** @type {(inputs: Domain_Search_Modal_Available_FreeInputs) => LocalizedString} */
const ru_domain_search_modal_available_free = en_domain_search_modal_available_free;

/** @type {(inputs: Domain_Search_Modal_Available_FreeInputs) => LocalizedString} */
const pt_domain_search_modal_available_free = en_domain_search_modal_available_free;

/** @type {(inputs: Domain_Search_Modal_Available_FreeInputs) => LocalizedString} */
const ko_domain_search_modal_available_free = en_domain_search_modal_available_free;

/**
* | output |
* | --- |
* | "Available & free" |
*
* @param {Domain_Search_Modal_Available_FreeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_search_modal_available_free = /** @type {((inputs?: Domain_Search_Modal_Available_FreeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Search_Modal_Available_FreeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_search_modal_available_free(inputs)
	if (locale === "es") return es_domain_search_modal_available_free(inputs)
	if (locale === "fr") return fr_domain_search_modal_available_free(inputs)
	if (locale === "de") return de_domain_search_modal_available_free(inputs)
	if (locale === "ja") return ja_domain_search_modal_available_free(inputs)
	if (locale === "zh") return zh_domain_search_modal_available_free(inputs)
	if (locale === "ar") return ar_domain_search_modal_available_free(inputs)
	if (locale === "id") return id_domain_search_modal_available_free(inputs)
	if (locale === "it") return it_domain_search_modal_available_free(inputs)
	if (locale === "ru") return ru_domain_search_modal_available_free(inputs)
	if (locale === "pt") return pt_domain_search_modal_available_free(inputs)
	return ko_domain_search_modal_available_free(inputs)
});